// extracted by mini-css-extract-plugin
module.exports = {"button":"_02712f2b3b--button--BJDNe"};